import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconCoin } from "@tabler/icons-react";

export default function APCostFilter({
  selected,
  setSelected,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
}) {
  let data: Item[] = [];
  for (let i = 0; i < 3; i++) {
    let cost = i;
    data.push({ key: String(cost), value: String(cost) });
  }
  return (
    <GenericFilter
      classNames="w-[120px]"
      selected={selected}
      selectionMode="single"
      setSelected={setSelected}
      label="AP Cost"
      startContent={<IconCoin height={30} width={30} />}
      data={data}
    />
  );
}
